(() => {
  if (window.nativePersonalizationReady) return;
  window.nativePersonalizationReady = true;

  const updateRoot = (root) => {
    const form = root.closest('form[action*="/cart/add"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const dataNode = root.querySelector('[data-native-personalization-variants]');
    if (!form || !variantInput || !dataNode) return;

    let variantMap;
    try {
      variantMap = JSON.parse(dataNode.textContent);
    } catch (error) {
      console.error('Native personalization variant data is invalid.', error);
      return;
    }

    const state = variantMap[String(variantInput.value)] || { personalized: false, classic: false };
    const paid = root.querySelector('[data-native-personalization-paid]');
    const classic = root.querySelector('[data-native-personalization-classic]');
    const standard = root.querySelector('[data-native-personalization-standard]');

    if (paid) paid.hidden = !state.personalized;

    root.querySelectorAll('[data-native-personalization-required]').forEach((input) => {
      const correctClassicStyle = !input.closest('[data-native-personalization-classic]') || state.classic;
      const correctStandardStyle = !input.closest('[data-native-personalization-standard]') || !state.classic;
      const enabled = state.personalized && correctClassicStyle && correctStandardStyle;
      input.disabled = !enabled;
      input.required = enabled;
    });

    root.querySelectorAll('[data-native-personalization-optional]').forEach((input) => {
      input.disabled = !state.personalized;
    });

    if (classic) classic.hidden = !state.classic;
    if (standard) standard.hidden = state.classic;
  };

  const updateAll = () => {
    document.querySelectorAll('[data-native-personalization]').forEach(updateRoot);
  };

  let updateTimer;
  const queueUpdate = () => {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(updateAll, 0);
    window.setTimeout(updateAll, 500);
  };

  const validatePersonalizationForm = (form) => {
    const root = form?.querySelector('[data-native-personalization]');
    if (!root) return true;

    updateRoot(root);
    if (form.checkValidity()) return true;

    form.reportValidity();
    const firstInvalid = form.querySelector(':invalid:not([disabled])');
    if (firstInvalid) {
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      window.setTimeout(() => firstInvalid.focus({ preventScroll: true }), 0);
    }
    return false;
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest?.('form[action*="/cart/add"]');
      if (!form || validatePersonalizationForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener(
    'click',
    (event) => {
      const paymentButton = event.target.closest?.(
        '.shopify-payment-button__button, shopify-accelerated-checkout, [data-shopify="payment-button"]'
      );
      if (!paymentButton) return;

      const form =
        paymentButton.closest('form[action*="/cart/add"]') ||
        paymentButton.closest('product-info')?.querySelector('form[action*="/cart/add"]');
      if (!form || validatePersonalizationForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true
  );

  document.addEventListener('change', queueUpdate, true);
  document.addEventListener('shopify:section:load', queueUpdate);
  new MutationObserver(queueUpdate).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateAll, { once: true });
  } else {
    updateAll();
  }
})();
